export function getFullPath() {
  return window.location.href;
}

export function getBasePath() {
  return `${window.location.protocol}//${window.location.host}`;
}
